module.exports = __webpack_public_path__ + "static/promo-video-1-3d164f9043ce6949b303176472bc5440.mp4";